import { ArrowRight, Check, Sparkles } from 'lucide-react'
import { Link } from 'react-router-dom'
import { TrailMap } from '../components/TrailMap'
import { WaveArtwork } from '../components/WaveArtwork'
import { useApp } from '../state/AppContext'

export function TodayPage() {
  const { user, journey, mode } = useApp()
  if (!journey) return <div className="page-loader">Preparando seu ciclo…</div>
  const complete = journey.activities.filter((item) => item.status === 'completed').length

  return <div className="today-page">
    <header className="page-heading page-heading--journey"><div><p>{mode === 'demo' ? 'Demonstração do ciclo' : `Olá, ${user?.name.split(' ')[0]}`}</p><h1>Siga a onda.<br /><em>Ela sabe o caminho.</em></h1></div></header>
    <section className="work-hero">
      <WaveArtwork />
      <div className="work-hero__meta"><p>Obra da semana · {journey.work.year}</p><h2>{journey.work.title}</h2><h3>{journey.work.composer}</h3><span>{journey.work.subtitle}</span></div>
      <div className="cycle-note"><Sparkles />{journey.cadenceLabel}</div>
    </section>
    <TrailMap activities={journey.activities} workTitle={journey.work.title} workComposer={journey.work.composer} />
    {complete === journey.activities.length && <section className="complete-banner"><Check /><div><p className="step-label">Ciclo completo</p><h2>Esta obra já faz parte de você.</h2><Link to="/partitura">Escrever na sua partitura <ArrowRight /></Link></div></section>}
  </div>
}
